import { z } from "zod"

import { actorTypes } from "../../taxonomy.js"
import { ApiUserSummarySchema } from "./users.js"

export const ApiAuditEventSchema = z.object({
  auditEventId: z.string().uuid(),
  organizationId: z.string().uuid(),
  workspaceId: z.string().uuid().nullable(),
  actorType: z.enum(actorTypes),
  actorUserId: z.string().nullable(),
  // Mirrored profile of the acting user; null for API keys and unresolved ids.
  actor: ApiUserSummarySchema.nullable().optional(),
  actorApiKeyId: z.string().uuid().nullable(),
  action: z.string(),
  targetType: z.string(),
  targetId: z.string(),
  summary: z.string(),
  createdAt: z.string().datetime(),
})

export type ApiAuditEvent = z.infer<typeof ApiAuditEventSchema>

export const ApiAuditLogResponseSchema = z.object({
  events: z.array(ApiAuditEventSchema),
  /** Opaque; pass back as ?cursor= to fetch the next (older) page. */
  nextCursor: z.string().nullable(),
})

export type ApiAuditLogResponse = z.infer<typeof ApiAuditLogResponseSchema>
